<template>
    <div>
        
        <template class="pa-3">
            <v-snackbar
                    v-model="snackbar" top vertical="" :timeout="5000"
                    >
                    {{ Mensaje }}
                    <v-btn
                    color="info"
                    text
                    @click="snackbar = false"
                    >
                    Cerrar
                    </v-btn>
            </v-snackbar>
            
            <v-row  flat color="white"  class="oculto-impresion pa-2">
				<v-col cols="12" sm="12">
					<v-row>
							<v-col v-if="esBoss" cols="12" sm="12" >
								<div >
									<div class="nav-area" >
									<div @click.stop class="navbar">
										<div style="display: grid; grid-template-columns: auto auto;">
											<div style="text-align: right;">
												<nav class="nav-area">
													<ul>
														<li v-for="x in options" :key="x">
															<a @click.stop @click="Ruta(x.title,0,0)">{{x.title}} </a>
															<ul>
																<li v-for="y in x.options" :key="y"> 
																	<a @click.stop @click="Ruta(x.title,y.title,0)" >{{y.title}}   </a>
																	<ul>
																		<li v-for="m in y.options" :key="m">
																			<a @click.stop @click="Ruta(x.title,y.title,m.title)" >{{m.title}} </a>
																		</li>
																	</ul>
																</li>
															</ul>
														</li>
													</ul>
												</nav>
											</div>
										</div>
									</div> 
									</div>
								</div>
							</v-col>
							<v-col cols="12" lg="3" md="5" sm="8" xs="12" >
								<p style="font-size: 30px"> Panorama General </p>
							</v-col>
							<v-col cols="12" lg="4" md="7" sm="4" xs="12">    
								<v-text-field filled v-model="search"  append-icon="mdi-magnify"
								label="Buscar" hide-details dense
								></v-text-field>
								<v-select hide-details clearable :items="Localidades" filled label="Localidad" v-model="Localidad"> </v-select>
							</v-col>
							<v-col cols="12" lg="2" md="6" sm="6" xs="6">
								<v-text-field dense hide-details filled v-model="start" type="date" label="Fecha inicial"></v-text-field>
								<v-select clearable hide-details filled dense @change="selectLocalidad()" :items="familias" v-model="familia" label="Filtrar por Familia"> </v-select>
							</v-col>
							<v-col cols="12" lg="2" md="5" sm="5" xs="5">
								<v-text-field hide-details filled v-model="end" dense type="date" label="Fecha final"></v-text-field>
								
								<v-select clearable dense hide-details filled @change="selectLocalidad()" :items="Proveedores" v-model="proveedor" label="Filtrar por Proveedor"> </v-select> 
							</v-col>
							<v-col cols="12" lg="1" md="1" sm="1" xs="1">
								<v-btn color="accent" @click="selectTipo()" fab > <v-icon fab> mdi-cloud-search </v-icon> </v-btn>
								<v-switch @change="selectTipo()" label="Slow Movers" color="error" v-model="SlowMover" /> 			
							</v-col>
							<v-col cols="12" lg="6" sm="6">
								<v-data-table
									:headers="headers"
									:items="usuarios"
									:single-expand="singleExpand"
									:expanded.sync="expanded"
									item-key="id"
									:loading="loading"
									show-expand
									:search="search"
									class="elevation-1"
									@click:row="handleRowExpansion"
								>
									<template v-slot:expanded-item="{ headers, item }">
									<td :colspan="headers.length">
										<v-btn @click="BuscarInventario(item.codigoProducto)" color="accent" small> Consultar inventario de : {{ item.descripcion }}</v-btn>
										<v-simple-table>
											<template v-slot:default>
											<thead>
												<tr>
												<th class="text-left">
													Articulo
												</th>
												<th class="text-left">
													Localidad
												</th>
												<th class="text-left">
													Cantidad
												</th>
												</tr>
											</thead>
											<tbody>
												<tr
												v-for="item in articulos"
												:key="item.codigoProducto"
												>
												<td>{{ item.descripcion }}</td>
												<td>{{ item.localidad }}</td>
												<td>{{ item.cantidadInvActual }}</td>
												</tr>
											</tbody>
											</template>
										</v-simple-table>
									</td>
									</template>
								</v-data-table>
							</v-col>
							<v-col cols="12" sm="6">
									<v-row class="d-flex justify-center flex-wrap">
										<v-btn @click="getProductosMasVendidos()" dark color="accent" class="mx-2 custom-button"> <v-icon> mdi-filter-variant</v-icon> Categoría 1 </v-btn>
										<v-btn @click="getProductosPorFamilia()" dark color="accent" class="mx-2 custom-button"> <v-icon> mdi-filter-variant</v-icon> Familia </v-btn>
										<v-btn @click="getProductosPorProveedor()" dark color="accent" class="mx-2 custom-button"> <v-icon> mdi-filter-variant</v-icon> Proveedor </v-btn>

									</v-row>
								<canvas id="myChart" >
									
								</canvas>
							</v-col>
					</v-row>
				</v-col>
               
                
                
            </v-row>
        </template>
    </div>
</template>
<script scoped>
import axios from 'axios'
import Chart from 'chart.js'

  export default {
    data: () => ({
		mesesValores: null,
		usuarios: [],
		familias: [],
		loading:true,
		articulos:[],
		SlowMover:false,
		Localidades:[],
		singleExpand: true,
		nombreMeses: [],
		totalMeses: [],
		expanded: [],
		search: '',
		categoria:'',
		familia: '',
		null:[],
		headers: [
		{ text: 'Codigo', value: 'codigoProducto' },
		{ text: 'Nombre', value: 'descripcion' },
		{ text: 'Cantidad', value: 'cantidad' },
		{ text: 'Precio', value: 'precioUnitario' },
		{ text: 'Descuentos', value: 'descuentos' },
		{ text: 'Total', value: 'totalLinea'},
		{ title: '', key: 'data-table-expand' },
		],
		today: new Date().toISOString().substr(0, 10),
		Localidad: null,
		Proveedores: [],
		proveedor: '',
		Mensaje: 'Seleccione un rango de fechas',
		snackbar: true,
		end: new Date().toISOString().slice(0, 10),
		start: new Date(new Date().getFullYear(), new Date().getMonth(), 1).toISOString().slice(0, 10),
		options: [
        {title: 'e-Liquids', options:[
          {title:'IMPORTADOS', options: [
			{title: 'RUTHLESS'},
            {title: 'BLVK Hundred'},
			{title: 'Naked', New: true},
            {title: 'Skwezed'},
			{title: 'VGOD'},
            {title: 'CoRE'},
            {title: 'CREAM TEAM'},
            {title: 'HI-Drip'},
            {title: 'Humble', New: true},
            {title: 'INNEVAPE'},
            {title: 'Jam Monster'},
            {title: 'Juice Head'},
            {title: 'Kings Crest'},
            {title: 'Mints'},
			{title: 'MR. FREEZE'},
			{title: 'Nasty'},
            {title: 'SHIJIN'},
            {title: 'Vapetasia'},
            {title: 'Yami Vapor'},
            {title: 'Zen Haus'},
			]},
          {title:'Nacionales', options:[
			{title: 'Pure Vape'},
			{title: 'Mike Bros'},
            {title: 'Primal Rage'},
			]}
        ]},

        {title: 'Nic Salts', options:[
			{title: 'Skwezed'},
			{title: 'FUME', New: true},
			{title: 'Mints'},
			{title: 'HUMBLE', New: true},
			{title: 'BLVK UNICORN'},
			{title: 'CoRE'},
			{title: 'Jam Monster'},
			{title: 'HI-DRIP'},
			{title: 'INNEVAPE'},
			{title: 'JUICE HEAD'},
			{title: 'MR. FREEZE'},
			{title: 'Nasty'},
			{title: 'SHIJIN'},
			{title: 'Kings Crest'},
			{title: 'VGOD', New: true},
			]},
		{title: 'Desechables', options:[
			{title: 'Desechables',options:[
				{title: 'Nasty'},
				{title: 'NAKED'},
				{title: 'HQD'},
				{title: 'LOOM'},
				{title: 'Dummy Vapes'},
				{title: 'Cali Bar 6000'},
				{title: 'Cali Bar 8000'},
				{title: 'Flum'},
				{title: 'NUUBEZ'},
				{title: 'Number 1'},
				{title: 'Lost Mary'},
				{title: 'QR'},
				{title: 'Elf Bar'},
				{title: 'Naked 100'}, 
				{title: 'Kado Bar'},
				{title: 'Loy'},
				{title: 'Foodgod'},
			]},
			{title:'Fume', options:[
			{title: 'Fume Ultra'},
			{title: 'Fume Extra'},
			{title: 'Fume Infinity'},
			{title: 'Fume Recharge'},
			]},
			{title:'Juice Head', options:[
			{title: 'No Freeze'},
			{title: 'Freeze'},
			{title: 'Extra Freeze'},
			]}
        ]},
		{title: 'Resistencias', options:[
			{title: 'Comerciales',options:[
				{title: 'Voopoo'},
				{title: 'Smok'},
				{title: 'Geek Vape'},
				{title: 'Sourin'},
				{title: 'DotMod'},
				{title: 'Uwell'},
				{title: 'Lost Vape'},
				{title: 'Vaporesso'},
			]},
			{title:'Reconstruibles', options:[
			{title: 'Wes Coil'},
			{title: 'Charro Coils'},
			{title: 'Bullet'},
			]},
			{title:'Empty Pods', options:[
			{title: 'Smok'},
			{title: 'Voopoo'},
			{title: 'Uwell'},
			{title: 'Sourin'},
			{title: 'Vaporesso'},
			{title: 'DotMod'},
			{title: 'Geek Vape'},
			]}
        ]},

        {title: 'Devices',options:[
			{title: 'Geek Vape'},
			{title: 'VOOPOO'},
			{title: 'Dotmod'},
			{title: 'HELL VAPE'},
			{title: 'IQOS'},
			{title: 'Lost Vape'},
			{title: 'SMOK'},
			{title: 'Suorin'},
			{title: 'UWELL'},
			{title: 'Vandy Vape'},
			{title: 'Vaporesso'},
			{title: 'YOCAN'},
		]},

		{title: 'Herb',options:[
			{title: 'Auxo'},
			{title: 'Baterias De Carts'},
			{title: 'Puffco'},
			{title: 'Raw'},
			{title: 'Hookah'},
			{title: 'RDTA'},
			{title: 'Cristaleria', New: true},
			{title: 'Tabacco'},
			{title: 'Pipas'},
		]
		},
        {title: 'Accesorios',options:[
			{title: 'Algodones'},
			{title: 'Baterias'},
			{title: 'Cargadores de baterias'},
			{title: 'Drip Tips'},
			{title: 'Pyrex-Glass'},
			{title: 'RDTA'},
			{title: 'RDA', New: true},
			{title: 'RTA Comercial'},
			{title: 'RTA Reconstruible'},
		]
		}
      ],


    }),
	computed: {
		esBoss(){
			return this.$store.state.usuario && this.$store.state.usuario.rol =='King Boss';
		},
    },
    watch: {
		dialog (val) {
			val || this.close()
		},
		SlowMover: {
			immediate: true,
			handler(newVal) {
			this.actualizarTabla();
		}
  }
      
    },

    methods: {
		actualizarTabla() {
			if (this.SlowMover) {
			// Ordenar por Cantidad de menor a mayor
			this.usuarios.sort((a, b) => a.cantidad - b.cantidad);
			} else {
			// Ordenar por Cantidad de mayor a menor
			this.usuarios.sort((a, b) => b.cantidad - a.cantidad);
			}
		},
		SelectJson() {
			let me = this;
			let header = {"Authorization": "Bearer " + this.$store.state.token};
			let configuracion = {headers: header};
			axios.get('menu.js', configuracion)
			.then(function (response) {
				me.JsonMenu = response.data;
			})
			.catch(function (error) {
				console.log(error);
			});
		},
		select(){
			let me=this;
			let header={"Authorization" : "Bearer " + this.$store.state.token};
			let configuracion= {headers : header};
			axios.get('api/VentasXProductoes/ConsultaPanoramaGeneral/'+this.today+'/'+this.today+'/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
				//console.log(response);
				me.usuarios=response.data;
			}).catch(function(error){
				console.log(error);
			});
        },
		handleRowExpansion(item) {
			this.BuscarInventario(item.codigoProducto);
		},
		BuscarInventario(codigo){
			this.modelCarga = true;
			let me=this;
			let items = [];
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			axios.get('api/ProductosWebs/'+codigo,configuracion).then(function(response){
				items=response.data;
				me.articulos = [];
				items.map(function(x){
					me.articulos.push({
						codigoProducto: x.codigoProducto,
						descripcion: x.descripcion,
						familia: x.familia,
						precioVenta: x.precioVenta,
						precioCompra: x.precioCompra,
						cantidadInvActual: x.cantidadInvActual,
						codigoBarras: x.codigoBarras,
						localidad: x.sitio,
						sincServer1: x.sincServer1,
					}
						);
				});
				me.modelCarga=false;
			}).catch(function(error){
				alert("Producto no encontrado");
				me.modelCarga=false;
			});
    	},
		async listarAsociadas(){
			var items = [];
			let me=this;
			this.Localidad = this.$store.state.usuario.localidad
			
			me.Localidades.push(me.$store.state.usuario.localidad);
			let header={"Authorization" : "Bearer "};
			let configuracion= {headers : header};
			await axios.get('api/LocalidadesAsociadas/'+this.$store.state.usuario.nombre,configuracion).then(function(response){
				items=response.data;
				items.map(function(x){
					me.Localidades.push(x.localdiadAsociada);
				});
			}).catch(function(error){
				alert("Producto no encontrado");
				me.modelCarga=false;
			});
    	},
		selectTipo(){
			if(this.esBoss){
				if(this.Localidad == null){
					this.selectData2()
				} else{
					
					this.selectData()
				}
			} else
			{
				this.selectData()
			}
		},
		async selectData() {
			let me = this;
			this.loading = true;
			let header = {
				"Authorization": "Bearer " + this.$store.state.token
			};
			let configuracion = {
				headers: header,
				params: {} // Aquí definimos un objeto vacío para los parámetros de consulta
			};

			// Si proveedor tiene un valor, lo añadimos al objeto params
			if (this.proveedor) {
				configuracion.params.proveedor = this.proveedor;
			}

			// Si familia tiene un valor, lo añadimos al objeto params
			if (this.familia) {
				configuracion.params.familia = this.familia;
			}
			if (this.categoria) {
				configuracion.params.Categoria1 = this.categoria;
			}
			let consulta = ''
			if(this.esBoss){

			} else
			{

			}
		
			if(this.SlowMover){
				consulta = 'ConsultaSlowMovers'
			} else
			{
				consulta = 'ConsultaPanoramaGeneral'
			}

			await axios.get('api/VentasXProductoes/' + consulta + '/' + this.start + '/' + this.end + '/' + this.Localidad, configuracion)
				.then(function(response) {
					me.usuarios = response.data;
					me.loading = false;
					me.actualizarTabla();
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		async selectData2() {
			let me = this;
			this.loading = true;
			let header = {
				"Authorization": "Bearer " + this.$store.state.token
			};
			let configuracion = {
				headers: header,
				params: {} // Aquí definimos un objeto vacío para los parámetros de consulta
			};

			// Si proveedor tiene un valor, lo añadimos al objeto params
			if (this.proveedor) {
				configuracion.params.proveedor = this.proveedor;
			}

			// Si familia tiene un valor, lo añadimos al objeto params
			if (this.familia) {
				configuracion.params.familia = this.familia;
			}
			if (this.categoria) {
				configuracion.params.Categoria1 = this.categoria;
			}
			let consulta = ''
		
			if(this.SlowMover){
				consulta = 'ConsultaSlowMovers2'
			} else
			{
				consulta = 'ConsultaPanoramaGeneral2'
			}

			await axios.get('api/VentasXProductoes/' + consulta + '/' + this.start + '/' + this.end, configuracion)
				.then(function(response) {
					me.usuarios = response.data;
					me.loading = false;
					me.actualizarTabla();
				})
				.catch(function(error) {
					console.log(error);
				});
		},
		selectProveedores(){
                let me=this;
                let header={"Authorization" : "Bearer " };
                let configuracion= {headers : header};
                var proveedoresArray=[];
                axios.get('api/proveedores/Select/'+me.$store.state.usuario.localidad,configuracion).then(function(response){
                    proveedoresArray=response.data;
                    proveedoresArray.map(function(x){
                        me.Proveedores.push(x.proveedor);
                    });
                }).catch(function(error){
                    console.log(error);
                });
		},
		selectFamilias(){
			let me=this;
			let header={"Authorization" : "Bearer " };
			let configuracion= {headers : header};
			var familiasArray=[];
			axios.get('api/Familias/Select/'+me.$store.state.usuario.localidad,configuracion).then(function(response){
				familiasArray=response.data;
				familiasArray.map(function(x){
					me.familias.push(x.nombre);
				});
			}).catch(function(error){
				console.log(error);
			});
        },
        loadProductosMasVendidos(){
            let me=this;
            let mesn='';
			this.nombreMeses = [];
			this.totalMeses = [];
            me.mesesValores.map(function(x){
				me.nombreMeses.push(x.innerPack + ' ('+x.cantidad+')');
				me.totalMeses.push(x.cantidad);
            });
            var ctx = document.getElementById("myChart");
            var myChart = new Chart(ctx, {
                type: 'doughnut',
				
                data: {
                    labels: me.nombreMeses,
                    datasets: [{
                        label: 'Ventas en los últimos 12 Meses',
                        data: me.totalMeses,
                        backgroundColor: [
							
							'rgba(75, 192, 192, 1)',
							'rgba(255, 99, 132, 1)',
							'rgba(54, 162, 235, 1)',
							'rgba(255, 206, 86, 1)',
							'rgba(153, 102, 255, 1)',
							'rgba(255, 159, 64, 1)',
							'rgba(201, 203, 207, 1)',
							'rgba(95, 99, 132, 1)',
							'rgba(54, 162, 125, 1)',
							'rgba(120, 206, 86, 1)',
							'rgba(153, 255, 102, 1)',
							'rgba(255, 92, 64, 1)',
							'rgba(202, 159, 64, 1)',
							'rgba(60, 160, 183, 1)',
							'rgba(255, 159, 254, 1)'
						],
						borderColor: [
							'rgba(75, 192, 192, 0.2)',
							'rgba(255, 99, 132, 0.2)',
							'rgba(54, 162, 235, 0.2)',
							'rgba(255, 206, 86, 0.2)',
							'rgba(153, 102, 255, 0.2)',
							'rgba(255, 159, 64, 0.2)',
							'rgba(201, 203, 207, 0.2)',
							'rgba(95, 99, 132, 0.2)',
							'rgba(54, 162, 125, 0.2)',
							'rgba(120, 206, 86, 0.2)',
							'rgba(153, 255, 102, 0.2)',
							'rgba(255, 92, 64, 0.2)',
							'rgba(202, 159, 64, 0.2)',
							'rgba(60, 160, 183, 0.2)',
							'rgba(255, 159, 254, 0.2)'
						],
                        borderWidth: 2
                    }]
                },
                options: {
					title: {          // Aquí añadimos el título
						display: true,
						text: 'Productos más Vendidos'  // Puedes personalizar el texto del título aquí
					},
					animation: {
						animateScale: true, // Habilita la animación de escala
						animateRotate: true // Habilita la animación de rotación
					},
                    scales: {
                        yAxes: [{
                            ticks: {
                                beginAtZero:true
                            }
                        }]
                    }
                }
            });
        },
        async getProductosMasVendidos(){
            let me=this;
			this.loading = true;
			//this.Localidad = this.$store.state.usuario.localidad;
			// Limpia el gráfico antes de cargar nuevos datos
			var ctx = document.getElementById("myChart");
			if (ctx) {
				var chart = new Chart(ctx, {
					type: 'doughnut',
					data: { labels: [], datasets: [] }
				});
			}
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};
            await axios.get('api/VentasXProductoes/ObtenerInnerPack/'+this.start+'/'+this.end+'/'+this.$store.state.usuario.localidad,configuracion).then(function(response){
                //console.log(response);
                me.mesesValores=response.data;
				me.loading = false;
                me.loadProductosMasVendidos();
            }).catch(function(error){
                console.log(error);
                alert("Error de conexión de graficos")
            });    
        },
		async getProductosPorFamilia(){
            let me=this;
			this.loading = true;
			// Limpia el gráfico antes de cargar nuevos datos
			var ctx = document.getElementById("myChart");
			if (ctx) {
				var chart = new Chart(ctx, {
					type: 'doughnut',
					data: { labels: [], datasets: [] }
				});
			}
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};
            await axios.get('api/VentasXProductoes/ObtenerFamilias/'+this.start+'/'+this.end+'/'+this.Localidad,configuracion).then(function(response){
                //console.log(response);
				me.mesesValores = null;
                me.mesesValores=response.data;
				me.loading = false;
                me.loadProductosMasVendidos();
            }).catch(function(error){
                console.log(error);
                alert("Error de conexión de graficos")
            });    
        },
		Ruta(title1,title2,title3){
			if(title1 != 0){
				this.categoria = title1;
			} else
			{
				this.categoria = null
			}
			if(title2 != 0){
				this.familia = title2;
			} else
			{
				this.familia = null
			}
			if(title2 != 0){
				this.proveedor = title3;
			} else
			{
				this.proveedor = null
			}
			this.selectTipo();
			
		},
		async getProductosPorProveedor(){
            let me=this;
			this.loading = true;
			// Limpia el gráfico antes de cargar nuevos datos
			var ctx = document.getElementById("myChart");
			if (ctx) {
				var chart = new Chart(ctx, {
					type: 'doughnut',
					data: { labels: [], datasets: [] }
				});
			}
            let header={"Authorization" : "Bearer " + this.$store.state.token};
            let configuracion= {headers : header};
            await axios.get('api/VentasXProductoes/ObtenerProveedores/'+this.start+'/'+this.end+'/'+this.Localidad,configuracion).then(function(response){
                //console.log(response);
                me.mesesValores=response.data;
				me.loading = false;
                me.loadProductosMasVendidos();
            }).catch(function(error){
                console.log(error);
                alert("Error de conexión de graficos")
            });    
        },
    },
	mounted(){
		this.listarAsociadas();
		this.selectProveedores();
		this.selectFamilias();
		this.selectTipo();
		this.getProductosPorFamilia();
	}
  }

</script>


<style scoped>
	.custom-button {
	border-radius: 0;
	}

	::v-deep .v-data-table tbody tr:nth-child(odd) {
	background-color: #f5f5f5; /*color de fondo para filas impares*/
	}

	::v-deep .v-data-table tbody tr:nth-child(even) {
	background-color: #ffffff; /*color de fondo para filas pares*/
	}
	::v-deep .my-custom-class tbody tr:nth-child(odd) {
	background-color: #f5f5f5; /*color de fondo para filas impares*/
	}

	::v-deep .my-custom-class tbody tr:nth-child(even) {
	background-color: #ffffff; /*color de fondo para filas pares*/
	}

	.navbar{
		background-color: black;
	}

	a {
		text-transform: uppercase;
		font-size: 12px;
		height: 50px;
		line-height: 1.5; /* Ajusta este valor según sea necesario */
	}
	.nav-area {
		height: 50px;

	}
	.nav-area:after {
		content: '';
		clear: both;
		display: block;
		
	}
	.nav-area ul {
		list-style: none;
		margin: 20;
	}
	.nav-area>ul>li {
		float: left;
		position: relative;
	}
	.nav-area ul li a {
		color: #fff;
		padding: 20px 15px;
		display: block;
		text-align: center;
		height: 50px;
	}
	.nav-area ul li:hover a {
		background: #262626;
		height: 30px;
		
		line-height: 1.5; /* Ajusta este valor según sea necesario */
	}
	.nav-area ul ul {
		position: absolute;
		padding: 0;
		min-width: 180px;
		display: none;
		top: 100%;
		bottom: 20%;
		left: 0;
		
		line-height: 1.5; /* Ajusta este valor según sea necesario */
	}
	.nav-area ul li:hover>ul {
		display: block;
	}
	.nav-area ul ul li:hover a {
		background: #7e7e7e;
	}
	.nav-area ul ul li {
		position: relative;
	}
	.nav-area ul ul ul {
		top: 0;
		left: 100%;
	}
	.nav-area ul ul ul li:hover a {
		background: #1d1d1d;
	}
</style>